import { useState } from "react";
import { Link2, Check } from "lucide-react";

export const ShareButton = ({ shortcode }) => {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const url = `${window.location.origin}/?post=${encodeURIComponent(shortcode)}`;
    if (navigator.share && window.matchMedia("(pointer: coarse)").matches) {
      navigator.share({ title: "HostNode", url }).catch(() => {});
      return;
    }
    await navigator.clipboard.writeText(url).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      data-testid="viewer-share-btn"
      onClick={share}
      className="ml-auto flex h-11 items-center gap-2 rounded-full border border-[var(--line)] px-5 text-sm transition-colors duration-300 hover:border-[var(--volt)] hover:text-[var(--volt)]"
    >
      {copied ? <Check className="h-4 w-4 text-[var(--volt)]" /> : <Link2 className="h-4 w-4" />}
      <span data-testid="viewer-share-label">{copied ? "Link copied" : "Share"}</span>
    </button>
  );
};
